'use client'

import { Moon, Sun } from 'lucide-react'
import { Button } from '@/components/ui/button'

const storageKey = 'nexline-theme'

export function ThemeToggle({ compact = false }: { compact?: boolean }) {
  function toggleTheme() {
    const isDark = document.documentElement.classList.contains('dark')
    const nextTheme = isDark ? 'light' : 'dark'

    try {
      window.localStorage.setItem(storageKey, nextTheme)
    } catch {}

    document.documentElement.classList.toggle('dark', nextTheme === 'dark')
    document.documentElement.style.colorScheme = nextTheme
  }

  if (compact) {
    return (
      <Button
        type="button"
        variant="outline"
        size="icon"
        onClick={toggleTheme}
        aria-label="Toggle color theme"
      >
        <Sun className="h-4 w-4 dark:hidden" aria-hidden="true" />
        <Moon className="hidden h-4 w-4 dark:block" aria-hidden="true" />
      </Button>
    )
  }

  return null
}
